import {of as observableOf, Observable} from 'rxjs';

import {map, first, distinctUntilChanged, debounceTime} from 'rxjs/operators';
import {Directive, forwardRef, Input} from '@angular/core';
import {AbstractControl, AsyncValidatorFn, NG_ASYNC_VALIDATORS, Validator} from '@angular/forms';
import {ResourceService} from '../../../resource.service';
import {FilterResult} from '../../../filterresult';
import {EnvironmentConfigService} from '../../../../core/services/environment-config.service';

@Directive({
  selector: '[uniqueValue]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: forwardRef(() => UniqueValueValidatorDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class UniqueValueValidatorDirective implements Validator {
  @Input() uniqueValue: string; // xpath

  constructor(
    private resourceService: ResourceService,
    private envConfig: EnvironmentConfigService,
  ) {}

  validate(control: AbstractControl): Observable<{[key: string]: any}> {
    return this.validateUniqueValue(control.value).pipe(
      debounceTime(500),
      distinctUntilChanged(),
      first(),
    );
  }

  validateUniqueValue(value: string): Observable<{[key: string]: any}> {
    if (this.uniqueValue == null || value == null || value.length == 0) {
      return observableOf(null);
    }

    const filterXPath = this.uniqueValue.replace('%VALUE%', value);
    return this.resourceService
      .searchResources(filterXPath, this.envConfig.getAttributeName('ObjectID'), 1)
      .pipe(
        map((res: FilterResult) => {
          if (res == null) return null;
          if (res.TotalCount == 0) {
            return null;
          } else {
            return {uniqueValue: value};
          }
        }),
      );
  }
}

export function uniqueValueValidator(
  xpath: string,
  initialValue: string,
  resourceService: ResourceService,
  objectIdAttribute: string = 'ObjectID',
): AsyncValidatorFn {
  return (control: AbstractControl): Observable<{[key: string]: any}> => {
    if (
      xpath == null ||
      xpath.length == 0 ||
      control.value == null ||
      control.value.length == 0 ||
      control.value == initialValue ||
      resourceService == null
    ) {
      return observableOf(null);
    }
    //TODO escape value?
    const filterXPath = xpath.replace('%VALUE%', control.value);
    return resourceService.searchResources(filterXPath, objectIdAttribute, 1).pipe(
      map((res: FilterResult) => {
        if (res == null) return null;
        if (res.TotalCount == 0) {
          return null;
        } else {
          return {uniqueValue: control.value};
        }
      }),
    );
  };
}
